import React from "react";

const Services = () => {
  return (
    <section id="services">
      <div className="bg-white mx-auto px-6 py-12 text-gray-800">
        <h2 className="text-3xl font-bold text-center mb-4 text-gray-900">
          Our Services
        </h2>
        {/* Title Divider */}
        <div className="w-16 h-1 bg-teal-600 mx-auto mb-8"></div>

        <p className="text-lg text-gray-600 text-center mb-12">
          At Arancia, we understand that every business has unique needs, which
          is why we offer flexible engagement models to align with your goals
          and operational preferences. Whether you require a comprehensive
          solution, a collaborative approach to scale operations, or tailored
          support for specific phases of your Odoo journey, we adapt to your
          requirements with agility. Our approach is designed to provide the
          right balance of control, expertise, and value, ensuring your business
          benefits from a seamless and cost-effective partnership. With a focus
          on building long-term relationships, we prioritize delivering results
          that matter to your success.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Strategic Consulting */}
          <div className="group bg-white shadow-xl rounded-lg p-6 border border-gray-200 transform transition-all duration-300 hover:scale-105 hover:bg-secondary hover:text-white">
            <h3 className="text-xl font-semibold text-secondary mb-4 group-hover:text-white transition-all duration-300">
              <i className="fas fa-lightbulb text-secondary text-6xl mb-4 mr-4 group-hover:text-white transition-all duration-300"></i>
              Strategic Consulting
            </h3>
            {/* Title Divider */}
            <div className="w-12 h-1 bg-secondary mb-4 transition-all duration-300 group-hover:w-full group-hover:bg-white"></div>

            <p className="text-sm text-gray-600 mb-4 text-justify group-hover:text-white transition-all duration-300">
              Our consulting services are designed to help you unlock the full
              potential of Odoo, ensuring enhanced efficiency across your
              organization. Whether your executive leadership is seeking to
              implement a more cost-effective ERP, enhance functionality, or
              simplify operations, our Strategic Business Consulting team is
              here to guide you every step of the way.
            </p>
          </div>

          {/* Odoo Implementation */}
          <div className="group bg-white shadow-xl rounded-lg p-6 border border-gray-200 transform transition-all duration-300 hover:scale-105 hover:bg-secondary hover:text-white">
            <h3 className="text-xl font-semibold text-secondary mb-4 group-hover:text-white transition-all duration-300">
              <i className="fas fa-cogs text-secondary text-6xl mb-4 mr-4 group-hover:text-white transition-all duration-300"></i>
              Odoo Implementation
            </h3>
            {/* Title Divider */}
            <div className="w-12 h-1 bg-secondary mb-4 transition-all duration-300 group-hover:w-full group-hover:bg-white"></div>

            <p className="text-sm text-gray-600 mb-4 text-justify group-hover:text-white transition-all duration-300">
              At Arancia, we bring extensive expertise in Odoo implementation
              across industries. Our end-to-end implementation services are
              tailored to your unique needs, ensuring that every module is
              configured to align seamlessly with your operations.
            </p>
            <ul className="list-disc list-inside text-sm text-gray-700 mb-4 text-justify group-hover:text-white transition-all duration-300">
              <li>
                <strong>Migration & Deployment:</strong> Seamlessly
                transitioning to Odoo while preserving data integrity.
              </li>
              <li>
                <strong>Implementation:</strong> Configuring Odoo to align with
                your unique goals.
              </li>
              <li>
                <strong>Extension:</strong> Custom module development to fit
                your business needs.
              </li>
            </ul>
          </div>

          {/* Odoo Support and Maintenance */}
          <div className="group bg-white shadow-xl rounded-lg p-6 border border-gray-200 transform transition-all duration-300 hover:scale-105 hover:bg-secondary hover:text-white">
            <h3 className="text-xl font-semibold text-secondary mb-4 group-hover:text-white transition-all duration-300">
              <i className="fas fa-headset text-secondary text-6xl mb-4 mr-4 group-hover:text-white transition-all duration-300"></i>
              Odoo Support and Maintenance
            </h3>
            {/* Title Divider */}
            <div className="w-12 h-1 bg-secondary mb-4 transition-all duration-300 group-hover:w-full group-hover:bg-white"></div>

            <p className="text-sm text-gray-600 mb-4 text-justify group-hover:text-white transition-all duration-300">
              With Arancia’s Odoo Support and Maintenance (OSM) services, you
              get peace of mind knowing your system is always running at its
              best. Our OSM services include proactive monitoring,
              troubleshooting, system updates, and performance optimization.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
